(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Botpoison", [], factory);
	else if(typeof exports === 'object')
		exports["Botpoison"] = factory();
	else
		root["Botpoison"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 